import React from 'react';

function TabPanel({ component: ContentComponent }) {
  return (
    <div><ContentComponent /></div>
  );
}

export default TabPanel;
